/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: CurrentProductListService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';
import { CurrentProductListData, CurrentProductListService }  from './CurrentProductList.service';


@Component({
  template: require('./CurrentProductListDetails.component.html'),
  providers: [CurrentProductListService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CurrentProductListDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objCurrentProductList: CurrentProductListData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private CurrentProductListService: CurrentProductListService

	) {
		// this.id = parseInt(params.get('id'));
		this.objCurrentProductList = new CurrentProductListData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.CurrentProductListService.getByID(+params['id']))
		.switchMap((params: Params) => this.CurrentProductListService.getByID(params['id']))
		.subscribe((item: CurrentProductListData) => this.objCurrentProductList = item);
		this.getLookups();
	}

	deleteCurrentProductList(id: string) {
		if (window.confirm('Are you sure you want to delete this CurrentProductList?') == true) 
		{
			this.CurrentProductListService.deleteCurrentProductList(this.objCurrentProductList.ProductID.toString())
			.subscribe(record => this.router.navigate(['/CurrentProductList']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('CurrentProductList record deleted successfully...'); }
			);
		}
	}
	gotoCurrentProductListEdit() {
		this.router.navigate(['/CurrentProductList', this.objCurrentProductList.ProductID]);
	}

	gotoCurrentProductList() {
		this.router.navigate(['/CurrentProductList']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CurrentProductList/CurrentProductListDetails.component.ts